import core from './core.js';
import transmit from './transmit.js';
import attention from './attention.js';
import visibility from './visibility.js';
import privatebrowsing from './privatebrowsing.js';
import heatmap from './heatmap.js';
import './click-path-capture.js';
import './perf.js';
import './iframe-tracking.js';
export * from './types/abtest.js';
export * from './types/acquisition.js';
export * from './types/subscription.js';
export * from './types/interaction.js';
export * from './types/inpageclick.js';
export * from './types/printproduct.js';
export * from './types/product.js';
export * from './types/platform.js';
export * from './types/media.js';
export * from './types/consent.js';
export * from './types/component-type.js';
export * from './types/component-event.js';
export * from './types/event.js';
let ng;
if (window.guardian && window.guardian.ophan) {
    ng = window.guardian.ophan;
}
else {
    core.init('next-gen');
    privatebrowsing.init();
    heatmap.init();
    if (window.addEventListener) {
        attention.init(visibility);
    }
    if (!window.guardian) {
        window.guardian = {};
    }
    window.guardian.ophan = {
        setEventEmitter: attention.setEventEmitter,
        trackComponentAttention: attention.initComponent,
        record: transmit.sendMore,
        viewId: transmit.viewId,
        pageViewId: transmit.viewId,
    };
    ng = window.guardian.ophan;
}
export default ng;
